import React from 'react';
import './CampaignPage.css';

import { Campaign, Heading, PageTitle } from '../../../components';
import { campaigns } from '../../../constants';



const CampaignPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Campaigns'} page={'Campaigns'} />

      <section className='campaigns'>

        {/* Section heading */}
        <Heading title={'Our Campaigns'} subTitle={'Community Support'} />

        <div className='box-container'>

          {/* Map over the campaigns array to render each campaign */}
          {campaigns.map((campaign) => { 
            return (
              <Campaign key={campaign.id} campaign={campaign} />
            );
          })}

        </div>

      </section>

    </>

  )
}

export default CampaignPage;